import ManualLink from '01_core/components/select/ManualLink';
import { withCallAPI } from '01_core/components/system/CallAPI';
import { withRouter } from '01_core/components/system/CustomRouter';
import { LABEL } from '01_core/constants/labelConsts';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { styles } from './styles';
import { styled } from '@mui/material/styles';

const stylesFromTheme = (theme) => (typeof styles === 'function' ? styles(theme) : styles);
const StyledManualUl = styled('ul')(({ theme }) => stylesFromTheme(theme).manualUl || {});

export class Manual extends Component {
  render() {
    const { intl, systemSettings } = this.props;
    return (
      <div>
        <b>{intl.formatMessage({ id: LABEL.COMMON_MANUAL_LIST })}</b>
        <StyledManualUl>
            <li>
              <ManualLink
                dispFileNm={intl.formatMessage({ id: LABEL.COMMON_MANUAL_GROUPHISAI })}
                fileNm={systemSettings.system_operation_manual_url_grouphisai_ja}
              />
            </li>
            <li>
              <ManualLink
                dispFileNm={intl.formatMessage({ id: LABEL.COMMON_MANUAL_SITEBUILDINGAREA })}
                fileNm={systemSettings.system_operation_manual_url_sitebuildingarea_ja}
              />
            </li>
            <li>
              <ManualLink
                dispFileNm={intl.formatMessage({ id: LABEL.COMMON_MANUAL_PERSONAL })}
                fileNm={systemSettings.system_operation_manual_url_personal_ja}
              />
            </li>
            <li>
              <ManualLink
                dispFileNm={intl.formatMessage({ id: LABEL.COMMON_MANUAL_BIZEXCSETTING })}
                fileNm={systemSettings.system_operation_manual_url_bizexcsetting_ja}
              />
            </li>
        </StyledManualUl>
        <b>{intl.formatMessage({ id: LABEL.COMMON_MANUAL_LIST_EN })}</b>
        <StyledManualUl>
            <li>
              <ManualLink
                dispFileNm={intl.formatMessage({ id: LABEL.COMMON_MANUAL_GROUPHISAI_EN })}
                fileNm={systemSettings.system_operation_manual_url_grouphisai_en}
              />
            </li>
            <li>
              <ManualLink
                dispFileNm={intl.formatMessage({ id: LABEL.COMMON_MANUAL_PERSONAL_EN })}
                fileNm={systemSettings.system_operation_manual_url_personal_en}
              />
            </li>
            <li>
              <ManualLink
                dispFileNm={intl.formatMessage({ id: LABEL.COMMON_MANUAL_BIZEXCSETTING_EN })}
                fileNm={systemSettings.system_operation_manual_url_bizexcsetting_en}
              />
            </li>
        </StyledManualUl>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  systemSettings: state.coreLoginInfo.systemSettings,
});

export default connect(mapStateToProps)(withRouter(injectIntl(withCallAPI(Manual))));
